import {size, each, toNumber, moment, createSelector, Moment, isObject} from 'vendor';
import type {AnyObject} from 'types';
import {RootState} from 'store/root-state.type';

export const id = (_: unknown, props: {id: string}) => isObject(props) ? props.id : undefined;

export const context = (_: unknown, props: {context: string}) => props?.context;

export const filter = (_: unknown, props: {filter: string}) => props?.filter;

export const timestamp = createSelector(
  (_: RootState, props: {date: Moment | string | number}) => props,
  (props) => {
    if (typeof props?.date === 'string') {
      return toNumber(props?.date);
    } else if (typeof props?.date === 'number') {
      return props?.date;
    } else if (props?.date) {
      return props?.date.unix();
    }
  }
);

export const date = createSelector(
  [timestamp],
  (timestamp) => timestamp ? moment.unix(timestamp) : null,
  {memoizeOptions: {maxSize: 1000}}
);

export const dateString = createSelector(
  [date],
  (date) => date?.format('MM/DD/YYYY')
);

export const module = (_: unknown, props: {module: string}) => props?.module;

export const name = (_: unknown, props: {name: string}) => props?.name;

export const category = (_: unknown, props: {category: string}) => props?.category;

export const type = (_: unknown, props: {type: string}) => props?.type;

export const action = (_: unknown, props: {action: string}) => props?.action;

export const length = (_: unknown, props: {length: string | number}) => `${props?.length}`.replace(/\D/g, '');

export function createdDate(props: {id: string | number}) {
  return parseInt(`${props?.id}`.substr(0, 10));
}

export function createdDateNegative(props: {id: string | number}) {
  return -1 * createdDate(props);
}

export function flatten(groups: AnyObject[] | {[key: string]: AnyObject[]}) {
  if (Array.isArray(groups)) {
    return groups;
  }
  let list: AnyObject[] = [];
  each(groups, (array, group) => {
    if (size(array)) {
      list = [
        ...list,
        {heading: group},
        ...array
      ];
    }
  });
  return list;
}

export {today} from 'store/session';
